import React from 'react';
import { connect } from 'react-redux';
import { toggleHeaderMenu } from '../../actions/uiActions';

import { getPageTitle } from '../../reducers/title';
import { getDrawerState } from '../../reducers/ui.header';
import Drawer from './Drawer';
import HeaderBase from './HeaderBase';
import HeaderToolbar from './HeaderToolbar';
import MainMenuDrawer from './MainMenuDrawer';

const Header = ({ title, page, toggleHeaderMenu, open }) => {
    const handleClose = () => toggleHeaderMenu();

    return (
        <React.Fragment>
            <HeaderBase
                Toolbar={HeaderToolbar}
                toggleMenu={handleClose}
                title={title}
                page={page}
                open={open}
                Drawer={<Drawer
                    toggleMenu={handleClose}
                    open={open}
                    Menu={<MainMenuDrawer />}
                />}
            />
        </React.Fragment>
    );
};

const makeMapStateToProps = initialState => {
    const { page } = initialState;
    const title = getPageTitle(initialState);
    return state => (
        {
            page,
            title,
            open: getDrawerState(state),
        }
    );
};

const MapDispatchToProps = dispatch => (
    { toggleHeaderMenu: () => dispatch(toggleHeaderMenu()) }
);

export default connect(makeMapStateToProps, MapDispatchToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/header/SewpatGallery.js